import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DonationContextType {
  showDonationForm: boolean;
  openDonationForm: (causeName?: string) => void;
  closeDonationForm: () => void;
  selectedCause: string | null;
}

const DonationContext = createContext<DonationContextType | undefined>(undefined);

export const DonationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showDonationForm, setShowDonationForm] = useState(false);
  const [selectedCause, setSelectedCause] = useState<string | null>(null);

  const openDonationForm = (causeName?: string) => {
    setSelectedCause(causeName || null);
    setShowDonationForm(true);
  };

  const closeDonationForm = () => {
    setShowDonationForm(false);
    setSelectedCause(null);
  };

  return (
    <DonationContext.Provider
      value={{
        showDonationForm,
        openDonationForm,
        closeDonationForm,
        selectedCause,
      }}
    >
      {children}
    </DonationContext.Provider>
  );
};

export const useDonation = () => {
  const context = useContext(DonationContext);
  if (context === undefined) {
    throw new Error('useDonation must be used within a DonationProvider');
  }
  return context;
};









